
    <svg class="svg-icon icon-icon">
      <use xlink:href="./assets/svg/app-sections.svg#icon-delete"></use>
    </svg>
  